package dev.inmo.wishlist.features.ui.auth.ui

import kotlinx.serialization.Serializable
import dev.inmo.wishlist.features.common.client.models.ViewConfig

@Serializable
class AuthViewConfig() : ViewConfig
